module.exports = __webpack_public_path__ + "static/media/image-video-10.1fe57994.png";